import React from "react";

import { Table } from "src/library/components/Tables";
import { ITableInstance } from "src/library/components/Tables/Table";
import { PaginatedParams } from "src/core/shared/api";
import { PageProps } from "src/pages/Router/routes";
import { ActionButton } from "src/library/components/Button";
import { IInheritedSetting } from "src/core/drops/api/drops.api";
import {
  InheritedSettingsScopeFilterParams,
  useInheritedSettingsApi
} from "src/core/shared/api/inheritedSettings.api";

import { leadTimeSettingsColumns } from "../tables";

const defaultPagination: PaginatedParams<IInheritedSetting> = {
  page: 0,
  limit: 10,
  offset: 0,
  sort: [ [ "name", "ASC" ] ]
};

export const LeadTimeSettingsTabCustomers: React.ReactFCWithChildren<PageProps<unknown>> = ({ ...props }) => {
  const TableRef = React.useRef<ITableInstance<IInheritedSetting>>(null);
  const [ setttingsResponse, getSettings ] = useInheritedSettingsApi("GET_SETTINGS_BY_SCOPE");

  const onFetchData = React.useCallback((filters: InheritedSettingsScopeFilterParams, pagination: PaginatedParams<IInheritedSetting>) => {
    getSettings({
      scope: "customer",
      pagination,
      filters: {
        ...filters,
        name: [ "delivery_week_leadtimes", "delivery_cutoff" ]
      }
    });
  }, [ getSettings ]);

  return (
    <Table
      filterable={false}
      tableId="leadTimeSettingsTabCustomersTable"
      ref={TableRef}
      tableOf={props.terminology.customer.plural.text}
      data={setttingsResponse.data ? setttingsResponse.data.result : []}
      onFetchData={onFetchData}
      mainAction={row => props.history.push(`/admin/customers/${row.original.customer.id}/lead-times`)}
      error={setttingsResponse.error}
      totalRows={setttingsResponse.data ? setttingsResponse.data.count : 0}
      pages={setttingsResponse.data ? setttingsResponse.data.pages : 0}
      loading={setttingsResponse.pending}
      defaultPagination={defaultPagination}
      columns={leadTimeSettingsColumns("customer", row => (
        <ActionButton
          title="Actions"
          items={[
            {
              title: "Edit Lead Times",
              action: () => {
                props.history.push(`/admin/customers/${row.original.customer.id}/lead-times`);
              }
            }
          ]}
        />
      ))}
    />
  );
};
